(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ate-beanie-patch-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ate-beanie-patch-bundle')) {
    customElements.define('ate-beanie-patch-bundle',class extends HTMLElement {
      connectedCallback() {
        if(this.initialized) return;
        this.initialized=true;
        this.data=JSON.parse(this.querySelector('[data-patch-data]').textContent);
        this.form=this.querySelector('form');
        this.hat=this.querySelector('[data-hat]');
        this.shape=this.querySelector('[data-patch-shape]');
        this.color=this.querySelector('[data-patch-color]');
        this.button=this.querySelector('[data-submit]');
        this.buttonText=this.button.textContent;
        this.money=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency});
        this.hat.selectedIndex=Array.from(this.hat.options).findIndex(o=>!o.disabled);
        this.shape.selectedIndex=Array.from(this.shape.options).findIndex(o=>!o.disabled);
        this.shape.addEventListener('change',()=>this.setPatch());
        this.color.addEventListener('change',()=>this.updateSummary());
        this.hat.addEventListener('change',()=>this.updateSummary());
        this.form.addEventListener('submit',event=>this.submit(event));
        this.button.addEventListener('click',event=>{event.stopImmediatePropagation();this.submit(event);},true);
        this.setPatch();
      }
      setPatch() {
        this.patch=this.data.patches.find(p=>p.handle===this.shape.value);
        this.color.replaceChildren();
        if(this.patch) this.patch.variants.forEach(v=>{
          const option=new Option(v.title+' — '+this.money.format(v.price/100)+(v.available?'':' · '+this.data.messages.unavailable),String(v.id));
          option.disabled=!v.available;
          option.dataset.price=v.price;
          option.dataset.image=v.image;
          this.color.append(option);
        });
        this.color.selectedIndex=Array.from(this.color.options).findIndex(o=>!o.disabled);
        this.updateSummary();
      }
      updateSummary() {
        const hat=this.hat.selectedOptions[0];
        const patch=this.color.selectedOptions[0];
        this.button.disabled=!hat||hat.disabled||!patch||patch.disabled;
        this.querySelector('[data-total]').textContent=this.money.format((Number(hat?.dataset.price||0)+Number(patch?.dataset.price||0))/100);
        const hatImage=this.querySelector('.ate-bundle__image img');
        if(hat&&hatImage) {hatImage.src=hat.dataset.image;hatImage.removeAttribute('srcset');hatImage.alt=hat.textContent;}
        const holder=this.querySelector('[data-patch-image]');
        holder.replaceChildren();
        if(patch&&this.patch) {const img=document.createElement('img');img.src=patch.dataset.image;img.alt=this.patch.title+' — '+patch.textContent;img.width=500;img.height=500;holder.append(img);this.querySelector('[data-patch-link]').href=this.patch.url+'?variant='+patch.value;}
      }
      showError(text) {const el=this.querySelector('[data-error]');el.textContent=text;el.hidden=false;}
      async submit(event) {
        event.preventDefault();
        if(this.busy||!this.form.reportValidity()) return;
        const file=this.form.querySelector('input[type=file]').files[0];
        const notes=this.form.querySelector('textarea');
        if(!notes.value.trim()) {notes.focus();this.showError(this.data.messages.missing_details);return;}
        if(!file||file.size>10*1024*1024||!(/\.(png|jpe?g|svg|pdf)$/i.test(file.name))) {this.showError(this.data.messages.file_error);return;}
        this.busy=true;this.button.disabled=true;this.button.textContent=this.data.messages.adding;
        this.querySelector('[data-error]').hidden=true;
        const bundleId=crypto.randomUUID();
        const body=new FormData(this.form);
        body.set('items[1][properties][Personalization notes]',notes.value.trim());
        body.set('items[1][properties][Beanie color]',this.hat.selectedOptions[0].textContent.split(' — ')[0]);
        for(const index of [0,1]) body.set('items['+index+'][properties][_hat_patch_bundle]',bundleId);
        const controls=Array.from(this.form.querySelectorAll('select,input,textarea'));
        controls.forEach(control=>control.disabled=true);
        let safeToRetry=false;
        try {
          const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',body});
          const added=await response.json();
          const cartResponse=await fetch(this.dataset.cartUrl+'.js',{cache:'no-store'});
          if(!cartResponse.ok) throw new Error(this.data.messages.uncertain);
          const cart=await cartResponse.json();
          const lines=cart.items.filter(item=>item.properties?._hat_patch_bundle===bundleId);
          const patchLine=lines.find(item=>String(item.variant_id)===this.color.value);
          const complete=response.ok&&!added.status&&lines.length===2&&patchLine?.properties?.Artwork&&patchLine?.properties?.['Personalization notes']===notes.value.trim();
          if(!complete) {
            for(const item of lines) {const removed=await fetch(this.dataset.cartUrl+'/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0})});if(!removed.ok) throw new Error(this.data.messages.uncertain);}
            safeToRetry=true;
            throw new Error(added.description||this.data.messages.add_error);
          }
          window.location.assign(this.dataset.cartUrl);
        } catch(error) {
          this.showError(safeToRetry?error.message:this.data.messages.uncertain);
          this.button.textContent=this.buttonText;
          this.busy=false;
          if(safeToRetry) {controls.forEach(control=>control.disabled=false);this.button.disabled=false;}
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ate-hat-patch-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ate-hat-patch-bundle')) {
    customElements.define('ate-hat-patch-bundle',class extends HTMLElement {
      connectedCallback() {
        if(this.initialized) return;
        this.initialized=true;
        this.data=JSON.parse(this.querySelector('[data-patch-data]').textContent);
        this.form=this.querySelector('form');
        this.hat=this.querySelector('[data-hat]');
        this.shape=this.querySelector('[data-patch-shape]');
        this.color=this.querySelector('[data-patch-color]');
        this.button=this.querySelector('[data-submit]');
        this.buttonText=this.button.textContent;
        this.money=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency});
        this.hat.selectedIndex=Array.from(this.hat.options).findIndex(o=>!o.disabled);
        this.shape.selectedIndex=Array.from(this.shape.options).findIndex(o=>!o.disabled);
        this.shape.addEventListener('change',()=>this.setPatch());
        this.color.addEventListener('change',()=>this.updateSummary());
        this.hat.addEventListener('change',()=>this.updateSummary());
        this.form.addEventListener('submit',event=>this.submit(event));
        this.setPatch();
      }
      setPatch() {
        this.patch=this.data.patches.find(p=>p.handle===this.shape.value);
        this.color.replaceChildren();
        if(this.patch) this.patch.variants.forEach(v=>{
          const option=new Option(v.title+' — '+this.money.format(v.price/100)+(v.available?'':' · '+this.data.messages.unavailable),String(v.id));
          option.disabled=!v.available;
          option.dataset.price=v.price;
          option.dataset.image=v.image;
          this.color.append(option);
        });
        this.color.selectedIndex=Array.from(this.color.options).findIndex(o=>!o.disabled);
        this.updateSummary();
      }
      updateSummary() {
        const hat=this.hat.selectedOptions[0];
        const patch=this.color.selectedOptions[0];
        this.button.disabled=!hat||hat.disabled||!patch||patch.disabled;
        this.querySelector('[data-total]').textContent=this.money.format((Number(hat?.dataset.price||0)+Number(patch?.dataset.price||0))/100);
        const hatImage=this.querySelector('.ate-bundle__image img');
        if(hat&&hatImage) {hatImage.src=hat.dataset.image;hatImage.removeAttribute('srcset');hatImage.alt=hat.textContent;}
        const holder=this.querySelector('[data-patch-image]');
        holder.replaceChildren();
        if(patch&&this.patch) {const img=document.createElement('img');img.src=patch.dataset.image;img.alt=this.patch.title+' — '+patch.textContent;img.width=500;img.height=500;holder.append(img);this.querySelector('[data-patch-link]').href=this.patch.url+'?variant='+patch.value;}
      }
      showError(text) {const el=this.querySelector('[data-error]');el.textContent=text;el.hidden=false;}
      async submit(event) {
        event.preventDefault();
        if(this.busy||!this.form.reportValidity()) return;
        const file=this.form.querySelector('input[type=file]').files[0];
        const notes=this.form.querySelector('textarea');
        if(!notes.value.trim()) {notes.focus();this.showError(this.data.messages.missing_details);return;}
        if(!file||file.size>10*1024*1024||!(/\.(png|jpe?g|svg|pdf)$/i.test(file.name))) {this.showError(this.data.messages.file_error);return;}
        this.busy=true;this.button.disabled=true;this.button.textContent=this.data.messages.adding;
        this.querySelector('[data-error]').hidden=true;
        const bundleId=crypto.randomUUID();
        const body=new FormData(this.form);
        body.set('items[1][properties][Personalization notes]',notes.value.trim());
        body.set('items[1][properties][Hat color]',this.hat.selectedOptions[0].textContent.split(' — ')[0]);
        for(const index of [0,1]) body.set('items['+index+'][properties][_hat_patch_bundle]',bundleId);
        const controls=Array.from(this.form.querySelectorAll('select,input,textarea'));
        controls.forEach(control=>control.disabled=true);
        let safeToRetry=false;
        try {
          const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',body});
          const added=await response.json();
          const cartResponse=await fetch(this.dataset.cartUrl+'.js',{cache:'no-store'});
          if(!cartResponse.ok) throw new Error(this.data.messages.uncertain);
          const cart=await cartResponse.json();
          const lines=cart.items.filter(item=>item.properties?._hat_patch_bundle===bundleId);
          const patchLine=lines.find(item=>String(item.variant_id)===this.color.value);
          const complete=response.ok&&!added.status&&lines.length===2&&patchLine?.properties?.Artwork&&patchLine?.properties?.['Personalization notes']===notes.value.trim();
          if(!complete) {
            for(const item of lines) {const removed=await fetch(this.dataset.cartUrl+'/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0})});if(!removed.ok) throw new Error(this.data.messages.uncertain);}
            safeToRetry=true;
            throw new Error(added.description||this.data.messages.add_error);
          }
          window.location.assign(this.dataset.cartUrl);
        } catch(error) {
          this.showError(safeToRetry?error.message:this.data.messages.uncertain);
          this.button.textContent=this.buttonText;
          this.busy=false;
          if(safeToRetry) {controls.forEach(control=>control.disabled=false);this.button.disabled=false;}
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ate-headwear-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ate-headwear-product')) {
    customElements.define('ate-headwear-product',class extends HTMLElement {
      connectedCallback() {
        if(this.initialized) return;
        this.initialized=true;
        this.data=JSON.parse(this.querySelector('[data-hw-data]').textContent);
        this.form=this.querySelector('form');
        this.color=this.querySelector('[data-color]');
        this.size=this.querySelector('[data-size]');
        this.quantity=this.querySelector('[data-quantity]');
        this.toggle=this.querySelector('[data-add-patch]');
        this.panel=this.querySelector('[data-patch-panel]');
        this.shape=this.querySelector('[data-patch-shape]');
        this.patchColor=this.querySelector('[data-patch-color]');
        this.button=this.querySelector('[data-submit]');
        this.money=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency});
        const prefix=this.dataset.productTitle+' — ';
        const labels=this.data.messages.gallery_labels;
        const native=(this.data.gallery||[]).filter(m=>m.media_type==='image').map(m=>{
          const description=(m.alt||'').startsWith(prefix)?m.alt.slice(prefix.length):'';
          const parts=description.split(' — ');
          const label=parts.slice(1).join(' — ')||'Front view';
          return {color:parts[0],label,src:m.src||m.preview_image?.src,alt:m.alt,width:m.width||m.preview_image?.width,height:m.height||m.preview_image?.height};
        });
        this.gallery=[...native,...(this.data.extraGallery||[])].filter(m=>m.src).map(m=>({...m,caption:labels[m.label]||labels['Front view']}));
        const current=this.data.variants.find(v=>String(v.id)===this.dataset.selected)||this.data.variants.find(v=>v.available)||this.data.variants[0];
        const colors=[...new Set(this.data.variants.map(v=>v.options[0]))];
        colors.forEach(c=>{const option=new Option(c,c);option.disabled=!this.data.variants.some(v=>v.options[0]===c&&v.available);this.color.append(option);});
        this.color.value=current.options[0];
        this.setSizes(current.options[1]);
        this.color.addEventListener('change',()=>this.setSizes());
        this.size.addEventListener('change',()=>this.update());
        this.quantity.addEventListener('input',()=>this.update());
        this.quantity.addEventListener('change',()=>this.update());
        this.querySelectorAll('[data-qty]').forEach(button=>button.addEventListener('click',()=>{this.quantity.value=button.dataset.qty;this.update();}));
        if(this.toggle) {
          this.data.patches.forEach((p,i)=>{const option=new Option(p.title,String(i));option.disabled=!p.variants.some(v=>v.available);this.shape.append(option);});
          const available=Array.from(this.shape.options).findIndex(o=>!o.disabled);
          this.shape.selectedIndex=available;
          this.toggle.disabled=available<0||!this.data.application?.available;
          this.setPatch();
          this.toggle.addEventListener('change',()=>{this.panel.hidden=!this.toggle.checked;this.panel.disabled=!this.toggle.checked;this.update();});
          this.shape.addEventListener('change',()=>this.setPatch());
          this.patchColor.addEventListener('change',()=>this.update());
        }
        this.button.addEventListener('click',event=>{event.stopImmediatePropagation();this.submit();},true);
        this.form.addEventListener('submit',event=>{event.preventDefault();event.stopImmediatePropagation();this.submit();},true);
        this.update();
      }
      setSizes(preferred) {
        const old=preferred||this.size.value;
        const variants=this.data.variants.filter(v=>v.options[0]===this.color.value);
        this.size.replaceChildren();
        [...new Set(variants.map(v=>v.options[1]))].forEach(s=>{const option=new Option(s||'One Size',s||'');option.disabled=!variants.some(v=>v.options[1]===s&&v.available);this.size.append(option);});
        const preserved=Array.from(this.size.options).find(o=>o.value===old&&!o.disabled);
        if(preserved) this.size.value=old;
        else this.size.selectedIndex=Array.from(this.size.options).findIndex(o=>!o.disabled);
        this.update();
      }
      setPatch() {
        this.patch=this.data.patches[Number(this.shape.value)];
        this.patchColor.replaceChildren();
        if(this.patch) this.patch.variants.forEach(v=>{const option=new Option(v.title+' — '+this.money.format((v.price+(this.data.application?.price||0))/100),String(v.id));option.disabled=!v.available;this.patchColor.append(option);});
        this.patchColor.selectedIndex=Array.from(this.patchColor.options).findIndex(o=>!o.disabled);
        this.update();
      }
      update() {
        this.variant=this.data.variants.find(v=>v.options[0]===this.color.value&&(v.options[1]||'')===this.size.value);
        this.patchVariant=this.patch?.variants.find(v=>String(v.id)===this.patchColor?.value);
        const patchOn=Boolean(this.toggle?.checked);
        const quantity=Number(this.quantity.value);
        const valid=Number.isInteger(quantity)&&quantity>0;
        const headPrice=this.variant?.price||0;
        const patchPrice=patchOn?(this.patchVariant?.price||0):0;
        const applicationPrice=patchOn?(this.data.application?.price||0):0;
        const rate=quantity>=50?15:quantity>=25?10:quantity>=10?5:0;
        const headFinal=headPrice-Math.floor(headPrice*rate/100);
        const patchFinal=patchPrice-Math.floor(patchPrice*(this.patch?.bulk?rate:0)/100);
        const q=valid?quantity:0;
        const original=(headPrice+patchPrice+applicationPrice)*q;
        const total=(headFinal+patchFinal+applicationPrice)*q;
        this.querySelector('[data-unit-price]').textContent=this.money.format(headPrice/100);
        this.querySelector('[data-headwear-total]').textContent=this.money.format(headPrice*q/100);
        this.querySelector('[data-patch-total]').textContent=this.money.format(patchPrice*q/100);
        this.querySelector('[data-patch-total-row]').hidden=!patchOn;
        this.querySelector('[data-application-total]').textContent=this.money.format(applicationPrice*q/100);
        this.querySelector('[data-application-total-row]').hidden=!patchOn;
        this.querySelector('[data-savings-row]').hidden=original===total;
        this.querySelector('[data-savings]').textContent='−'+this.money.format((original-total)/100);
        this.querySelector('[data-total]').textContent=this.money.format(total/100);
        this.querySelector('[data-bulk-shipping]').hidden=rate===0;
        this.querySelectorAll('[data-qty]').forEach(button=>button.setAttribute('aria-pressed',String((rate===5&&button.dataset.qty==='10')||(rate===10&&button.dataset.qty==='25')||(rate===15&&button.dataset.qty==='50'))));
        let max=this.variant?.tracked?this.variant.inventory:10000;
        if(patchOn&&this.patchVariant?.tracked) max=Math.min(max,this.patchVariant.inventory);
        this.quantity.max=String(Math.max(1,max||1));
        this.quantity.setCustomValidity(valid&&quantity<=max?'':this.data.messages.quantity_error);
        const available=Boolean(this.variant?.available)&&(!patchOn||(Boolean(this.patchVariant?.available)&&Boolean(this.data.application?.available)));
        this.button.disabled=this.busy||!available||!valid||quantity>max;
        this.button.textContent=this.busy?this.data.messages.adding:available?this.data.messages.add:this.data.messages.sold_out;
        this.querySelector('[data-stock]').textContent=available?this.data.messages.available:this.data.messages.sold_out;
        this.setGallery();
        if(this.patchVariant) {const img=this.querySelector('[data-patch-image]');img.src=this.patchVariant.image;img.alt=this.patch.title+' — '+this.patchVariant.title;this.querySelector('[data-patch-price]').textContent=this.money.format((this.patchVariant.price+(this.data.application?.price||0))/100)+' '+this.data.messages.per_patch;}
        if(this.variant) {const url=new URL(window.location.href);if(url.searchParams.get('variant')!==String(this.variant.id)){url.searchParams.set('variant',String(this.variant.id));window.history.replaceState({},'',url);}}
      }
      galleryUrl(src,width) {
        const url=new URL(src,window.location.href);
        if(url.hostname==='cdn.shopify.com'||url.hostname===window.location.hostname) url.searchParams.set('width',String(width));
        return url.href;
      }
      setGallery() {
        const color=this.variant?.options[0];
        if(!color||this.galleryColor===color) return;
        this.galleryColor=color;
        const order=['Front view','Angled view','Side view','Back view','On model, front','On model, side','On model, back'];
        const seen=new Set();
        this.galleryItems=this.gallery.filter(m=>m.color===color).filter(m=>{const key=m.src.split('?')[0];if(seen.has(key)) return false;seen.add(key);return true;}).sort((a,b)=>order.indexOf(a.label)-order.indexOf(b.label));
        if(!this.galleryItems.length&&this.variant.image) this.galleryItems=[{src:this.variant.image,alt:this.dataset.productTitle+' — '+color,caption:this.data.messages.gallery_labels['Front view']}];
        const tray=this.querySelector('[data-gallery-thumbnails]');
        const fragment=document.createDocumentFragment();
        this.galleryItems.forEach((item,index)=>{
          const button=document.createElement('button');
          button.type='button';
          button.className='ate-hw__thumbnail';
          button.setAttribute('aria-label',color+' — '+item.caption);
          button.setAttribute('aria-pressed','false');
          const image=document.createElement('img');
          image.src=this.galleryUrl(item.src,180);
          image.alt='';
          image.width=160;
          image.height=160;
          image.loading='lazy';
          image.decoding='async';
          const caption=document.createElement('span');
          caption.textContent=item.caption;
          button.append(image,caption);
          button.addEventListener('click',()=>this.showGalleryImage(index));
          fragment.append(button);
        });
        tray.replaceChildren(fragment);
        tray.hidden=this.galleryItems.length<2;
        this.querySelector('[data-gallery-caption]').hidden=this.galleryItems.length<2;
        this.showGalleryImage(0);
      }
      showGalleryImage(index) {
        const item=this.galleryItems[index];
        const hero=this.querySelector('.ate-hw__hero img');
        if(!item||!hero) return;
        hero.src=this.galleryUrl(item.src,1200);
        hero.removeAttribute('srcset');
        hero.alt=item.alt||this.dataset.productTitle+' — '+this.galleryColor+' — '+item.caption;
        if(item.width&&item.height) {hero.width=item.width;hero.height=item.height;}
        this.querySelector('[data-gallery-caption]').textContent=this.galleryColor+' — '+item.caption;
        this.querySelectorAll('.ate-hw__thumbnail').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
      }
      showError(message) {const el=this.querySelector('[data-error]');el.textContent=message;el.hidden=false;}
      async submit() {
        if(this.busy||!this.form.reportValidity()||this.button.disabled) return;
        const withPatch=Boolean(this.toggle?.checked);
        const file=withPatch?this.querySelector('[data-artwork]').files[0]:null;
        const notes=withPatch?this.querySelector('[data-notes]').value.trim():'';
        if(withPatch&&(!file||file.size>10*1024*1024||!(/\.(png|jpe?g|svg|pdf)$/i.test(file.name)))) {this.showError(this.data.messages.file_error);return;}
        if(withPatch&&!notes) {this.showError(this.data.messages.notes_error);return;}
        const nonce=crypto.randomUUID();
        const quantity=Number(this.quantity.value);
        const body=new FormData();
        body.set('items[0][id]',String(this.variant.id));
        body.set('items[0][quantity]',String(quantity));
        body.set('items[0][properties][_hat_patch_bundle]',nonce);
        if(withPatch) {
          body.set('items[0][properties][Bundle]','Headwear + personalized patch');
          body.set('items[0][properties][_ate_bundle_role]','headwear');
          body.set('items[1][id]',String(this.patchVariant.id));
          body.set('items[1][quantity]',String(quantity));
          body.set('items[1][properties][_hat_patch_bundle]',nonce);
          body.set('items[1][properties][_ate_bundle_role]','patch');
          body.set('items[1][properties][Bundle]','Headwear + personalized patch');
          body.set('items[1][properties][Headwear]',this.dataset.productTitle);
          body.set('items[1][properties][Headwear color]',this.variant.options[0]);
          body.set('items[1][properties][Headwear size]',this.variant.options[1]||'One Size');
          body.set('items[1][properties][Personalization notes]',notes);
          body.set('items[1][properties][Artwork]',file);
          body.set('items[2][id]',String(this.data.application.id));
          body.set('items[2][quantity]',String(quantity));
          body.set('items[2][properties][_hat_patch_bundle]',nonce);
          body.set('items[2][properties][_ate_bundle_role]','application');
          body.set('items[2][properties][Bundle]','Headwear + personalized patch');
          body.set('items[2][properties][Headwear]',this.dataset.productTitle);
          body.set('items[2][properties][Headwear color]',this.variant.options[0]);
          body.set('items[2][properties][Headwear size]',this.variant.options[1]||'One Size');
        }
        this.busy=true;
        this.querySelector('[data-error]').hidden=true;
        const controls=Array.from(this.form.querySelectorAll('select,input,textarea'));
        controls.forEach(el=>el.disabled=true);
        this.update();
        let safeToRetry=false;
        try {
          const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',body});
          const added=await response.json();
          const cartResponse=await fetch(this.dataset.cartUrl+'.js',{cache:'no-store'});
          if(!cartResponse.ok) throw new Error(this.data.messages.uncertain);
          const cart=await cartResponse.json();
          const lines=cart.items.filter(line=>line.properties?._hat_patch_bundle===nonce);
          const patchLine=lines.find(line=>String(line.variant_id)===String(this.patchVariant?.id));
          const expected=withPatch?[this.variant.id,this.patchVariant.id,this.data.application.id]:[this.variant.id];
          const complete=response.ok&&!added.status&&lines.length===expected.length&&expected.every(id=>lines.filter(line=>String(line.variant_id)===String(id)).length===1)&&lines.every(line=>line.quantity===quantity)&&(!withPatch||(patchLine?.properties?.Artwork&&patchLine.properties['Personalization notes']===notes));
          if(!complete) {
            for(const line of lines) {const removed=await fetch(this.dataset.cartUrl+'/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})});if(!removed.ok) throw new Error(this.data.messages.uncertain);}
            safeToRetry=true;
            throw new Error(added.description||this.data.messages.add_error);
          }
          window.location.assign(this.dataset.cartUrl);
        } catch(error) {
          this.busy=false;
          this.showError(safeToRetry?error.message:this.data.messages.uncertain);
          if(safeToRetry) {controls.forEach(el=>el.disabled=false);if(this.panel)this.panel.disabled=!this.toggle.checked;this.update();}
          else {this.button.disabled=true;this.button.textContent=this.data.messages.add;}
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
